import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Divider } from '@material-ui/core';
import PriceWrapper from 'components/PriceWrapper/PriceWrapper';
import { currencyToSymbol } from 'utils/currencies';
import { makeStyles } from '@material-ui/styles';

import BoxSection from '../BoxSection';
import Item from '../DietSummary/Item';

const useStyles = makeStyles({
  divider: {
    margin: '16px 0',
  },
  dietWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  summaryDescription: {
    marginTop: '15px',
  },
  boxSection: { margin: '5px' },
});

const OrderSummarySection = ({ diets, orderCost } = {}) => {
  const { t } = useTranslation();

  const classes = useStyles();

  const validationArray = diets.map(
    diet =>
      (diet.address || !!diet.pickUpPoint) &&
      diet.dietLength === diet.selectedDays.length &&
      !!diet.selectedDays &&
      !!diet.selectedDiet &&
      !!diet.selectedAddons &&
      !!diet.selectedVariant &&
      !!diet.selectedCalorific
  );
  const areAllDietsValid = validationArray.every(el => el === true);

  const priceLeftToPay = orderCost?.basket?.price?.afterDiscount;
  const priceBeforeDiscount = orderCost?.basket?.price?.beforeDiscount;
  const useMoneyBox = orderCost?.basket?.useMoneybox;
  const useMoneyBoxValue = orderCost?.basket?.price?.discountParts.MONEYBOX;

  const currency = useSelector(
    state => state?.Brands?.brand?.multinational?.currency
  );

  return (
    <BoxSection
      title={t('orders.toPay')}
      style={{ margin: '5px' }}
      headerRightCornerComponent={
        <>
          {areAllDietsValid ? (
            <PriceWrapper
              beforeDiscount={priceBeforeDiscount}
              afterDiscount={priceLeftToPay}
            />
          ) : null}
        </>
      }
    >
      <div>
        {areAllDietsValid ? (
          <>
            {diets.map((diet, index) => {
              const selectedDietLabel = diet.selectedDiet?.label || null;
              const selectedVariantLabel = diet.selectedVariant?.label || null;
              const selectedCalorificLabel =
                diet.selectedCalorific?.label || null;

              return (
                <div key={diet.id} className={classes.dietWrapper}>
                  <span>
                    {diet?.customDietName ||
                      [
                        selectedDietLabel,
                        selectedVariantLabel,
                        selectedCalorificLabel,
                      ]
                        .filter(Boolean)
                        .join(', ') ||
                      ''}
                  </span>
                  <PriceWrapper
                    style={{ wrapper: { fontWeight: '300' } }}
                    beforeDiscount={
                      orderCost?.basket?.rows?.[index]?.price?.beforeDiscount
                    }
                    afterDiscount={
                      orderCost?.basket?.rows?.[index]?.price?.afterDiscount
                    }
                  />
                </div>
              );
            })}
            {useMoneyBox && useMoneyBoxValue > 0 && (
              <>
                <Divider className={classes.divider} />
                <Item
                  title={`${t('orders.moneyBoxValue')}${currencyToSymbol(
                    currency
                  )}`}
                  isValidator={true}
                  value={useMoneyBoxValue}
                />
              </>
            )}
          </>
        ) : (
          <p className={classes.summaryDescription}>
            {t('orders.order.summaryShow')}
          </p>
        )}
      </div>
    </BoxSection>
  );
};

export default OrderSummarySection;
